'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  PricingRuleModel,
  CatalogModel,
  CountryModel,
} from '@marketplace-web/escrow-pricing/escrow-pricing-data'

import usePricingRuleDataFormatter from '../hooks/use-pricing-rule-data-formatter'
import PriceRuleTitle from './PricingRuleTitle'
import PriceRuleDataRow from './PriceRuleDataRow'
import TargetedCampaignNote from './TargetedCampaignNote'
import FactGroupList from './FactGroupList'

type Props = {
  priceRule: PricingRuleModel
  countries?: Array<CountryModel> | null
  catalogs?: Array<CatalogModel>
}

const PriceRuleSection = ({ priceRule, countries, catalogs }: Props) => {
  const translate = useTranslate('available_discounts')
  const priceRuleData = usePricingRuleDataFormatter({ priceRule, countries, catalogs })

  return (
    <section className="available_discounts__price-rule-section">
      <PriceRuleTitle priceRule={priceRule} />
      <TargetedCampaignNote priceRule={priceRule} />
      <div className="available_discounts__price-rule-card">
        <div>
          <h3 className="available_discounts__pricing-rule-card-title">
            {translate('discount_terms_label')}
          </h3>
          {priceRuleData.map(ruleDataRow => (
            <PriceRuleDataRow key={ruleDataRow.label} ruleDataRow={ruleDataRow} />
          ))}
        </div>
        <FactGroupList priceRule={priceRule} countries={countries} catalogs={catalogs} />
      </div>
    </section>
  )
}

export default PriceRuleSection
